import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <motion.div 
      className="section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        <div className="about-grid">
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-red">Our Story</h1>
            <p className="text-gold" style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
              Value. Vantage. ValuVant.
            </p>
            <p>
              ValuVant Solutions was founded on the principle that high-end digital services should be both valuable and relevant. The name itself reflects our DNA—a commitment to delivering measurable value while maintaining the "vantage point" necessary to navigate the complexities of modern marketing.
            </p>
            <br />
            <p>
              We didn't start as just another agency; we started as a response to the fragmented nature of the creative industry. We saw brands struggling to coordinate between a web developer who didn’t understand branding, and a social media manager who didn’t have the right assets. We built ValuVant to be the all-in-one ecosystem.
            </p>
          </motion.div>
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {/* Placeholder for an image */}
            <div style={{ 
              backgroundColor: '#eee', 
              height: '400px', 
              borderRadius: '8px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundImage: 'url(https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80)',
              backgroundSize: 'cover'
            }}>
            </div>
          </motion.div>
        </div>

        <div style={{ marginTop: '4rem' }}>
          <motion.h2 
            style={{ textAlign: 'center' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Mission & Vision
          </motion.h2>
          <div className="services-grid">
            <motion.div 
              className="service-card" 
              style={{ borderColor: 'var(--primary-red)' }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <h3 className="text-red">Our Mission</h3>
              <p>To empower businesses of all sizes by providing world-class creative and technical solutions that drive visibility, engagement, and sustainable growth.</p>
            </motion.div>
            <motion.div 
              className="service-card" 
              style={{ borderColor: 'var(--primary-gold)' }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <h3 className="text-gold">Our Vision</h3>
              <p>To become the global benchmark for digital transformation, where every brand we touch becomes a leader in its industry.</p>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default About;